module.exports = __webpack_public_path__ + "0ebaa340f6068b2dda9604d9d512cb72.svg";